import { Product } from './product';
import { ProductAvailability } from './product-availability';
import { ProjectHealth } from './project-health';
import { CableCut } from './cable-cut';

export class BomLine {
  id: string;
  partNumber: string;
  quantity: number;
  isCableItem: boolean;
  aboveLineComment: string;
  belowLineComment: string;
  sectionHeader: string;
  poLineNumber: number;
  index: number;
  manufacturerName: string;
  manufacturerPartNumber: string;
  shortDescription: string;

  consignmentAliasSku: string;
  isConsignmentItem: boolean;
  createdBy: string;

  isPlaceHolderItem: boolean;
  placeHolderDescr: string;
  placeHolderManuf: string;
  placeHolderManufPartNumber: string;
  placeHolderPrice: number;

  cableCuts: CableCut[];

  details?: Product;
  availability?: ProductAvailability;
  health?: ProjectHealth;

  message?: string;
  isNew?: boolean;
  isDeleted?: boolean;
  isSelected?: boolean = false;
  accountNumber: string;
  isCableSkuQtyAdjusted: boolean;
}

export class BomLineInput {
  worksheetId: string;
  bomLineId: string;
  bomId: string;
  partNumber: string;
  isCableItem: boolean;
  quantity: number;
  isPlaceHolderItem: boolean = false;
  aboveLineComment: string;
  belowLineComment: string;
  accountNumber: string;
  index: number;
  sectionHeader: string;
  manufacturerName: string;
  manufacturerPartNumber: string;
  shortDescription: string;
  poLineNumber: number;
}

export class BomLinesRequest {
  worksheetId: string;
  bomId: string;
  customerNumber: string;
  orgId: string;
  bomLines: BomLine[];
  sectionHeader: string;
}

export class WorksheetCommentsRequest {
  bomId: string;
  commentUserId: string;
  comments: string;
  oldComment: string;
  fileId: string;
  commentId: string;
  isEdit: boolean;
  isDelete: boolean;
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/bom-line.ts